export const userLocationSelector = ({userLocation}) => userLocation